import React, { useEffect, useState, useCallback } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";

import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n/I18nProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import { reapplyStoredConsent } from "@/consent";

function LangLayout({ children }) {
  const { lang } = useParams();
  const location = useLocation();
  const [openBannerSignal, setOpenBannerSignal] = useState(0);
  const openPreferences = useCallback(() => setOpenBannerSignal((n) => n + 1), []);

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}${location.pathname.replace(/^\/[^/]+/, "")}`} replace />;
  }

  return (
    <I18nProvider lang={lang}>
      <div className="dma-app">
        <Header />
        {children}
        <Footer onManagePreferences={openPreferences} />
        <CookieBanner openSignal={openBannerSignal} />
      </div>
    </I18nProvider>
  );
}

function LangRoutes() {
  return (
    <LangLayout>
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="cookies" element={<Cookies />} />
        <Route path="terms" element={<Terms />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </LangLayout>
  );
}

function App() {
  useEffect(() => {
    // Re-apply any previously stored consent so gtag reflects it on page load.
    reapplyStoredConsent();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang/*" element={<LangRoutes />} />
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
